const payrollMenu = [
  {
    System: 'PAYROLL',
    isActive: false,
    menu: [
      { is_header: true, title: 'PayrollManagement', isActive: true }, // عنوان القائمة الرئيسي

    
      {
        path: '/PAY/HomePage',
        icon: 'fas fa-home',
        title: 'HomePage',
        isActive: true
      },

      { is_header: true, title: 'Settings', isActive: true },
      {
        path: '/PAY/payrolls',
        icon: 'fas fa-money-check-alt',
        title: 'Payrolls',
        permission: 'PayViewPayrollList',
        isActive: true
      },

      {
        path: '/PAY/PayrollElement',
        icon: 'fas fa-file-invoice-dollar',
        title: 'PayrollElements',
        permission: 'PayViewListPayrollElement',
        isActive: true
      },
      {
        path: '/PAY/PayrollElementEntry',
        icon: 'fas fa-file-alt',
        title: 'PayrollElementEntry',
        permission: 'PayPayrollElementEntries',
        isActive: true
      },

      { is_header: true, title: 'RunPayrolls', isActive: true },

      {
        path: '/PAY/payrollsRun',
        icon: 'fas fa-play',
        title: 'RunPayrolls',
        permission: 'PayCreatRunPayroll',
        isActive: true
      },

      // {
      //   path: 'Pay/QuickPay',
      //   icon: 'fas fa-bolt',
      //   title: 'QuickPay',
      //   isActive: HasPermission('PayCreatePayrollQuickPay'),
      // },

      {
        path: '/PAY/ShowPayrollRun',
        icon: 'fas fa-file-invoice',
        title: 'ShowAllRuns',
        permission: 'PayViewPayrollRun',
        isActive: true
      },

      { is_header: true, title: 'Reports', isActive: true },

      {
        path: '/PAY/Reports',
        icon: 'fas fa-chart-bar',
        title: 'Reports',
        isActive: true
      },

      {
        path: '/PAY/Dashboard',
        icon: 'bi bi-cpu',
        title: 'Dashboard',
        isActive: true
        // highlight: true,
      }
    ]
  }
];

export default payrollMenu;

// { is_header: true, title: 'PAYROLL', isActive: true },
// {
//   path: 'dashboard',
//   icon: 'fas fa-home',
//   title: 'HomePage',
// },

// {
//   path: '/Pay',
//   icon: 'fas fa-money-bill-alt',
//   title: 'PayrollManagement',
//   children: [
//     {
//       path: 'Pay/payrolls',
//       title: 'PayrollsSettings',
//       isActive: HasPermission('PayViewPayrollList'),
//     },

//     {
//       path: 'Pay/PayrollElement',
//       title: 'PayrollElements',
//       isActive: HasPermission('PayViewListPayrollElement'),
//     },

//     {
//       path: 'Pay/payrollsRun',
//       title: 'RunPayrolls',
//       isActive: HasPermission('PayCreatRunPayroll'),
//     },
//     {
//       path: 'Pay/QuickPay',
//       title: 'QuickPay',
//       isActive: HasPermission('PayCreatePayrollQuickPay'),
//     },

//     {
//       path: 'Pay/PayrollElementEntry',
//       title: 'PayrollElementEntry',
//       isActive: HasPermission('PayPayrollElementEntries'),
//     },
//   ],
// },
